import { useState } from 'react'
import { CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts'

import { Button } from '@/components/ui/button'
import type { EmailReportBucket } from '@/models/emailReport'

type Mode = 'counts' | 'rates'

const COUNT_SERIES = [
  { key: 'sent', color: '#6366f1' },
  { key: 'opened', color: '#22c55e' },
  { key: 'clicked', color: '#f59e0b' },
]
const RATE_SERIES = [
  { key: 'openRate', color: '#22c55e' },
  { key: 'clickRate', color: '#f59e0b' },
]

export function EmailRateChart({ buckets }: { buckets: EmailReportBucket[] }) {
  const [mode, setMode] = useState<Mode>('counts')
  const series = mode === 'counts' ? COUNT_SERIES : RATE_SERIES

  return (
    <div className="flex flex-col gap-3">
      <div className="flex items-center justify-between">
        <div className="flex gap-2">
          <Button variant={mode === 'counts' ? 'default' : 'outline'} onClick={() => setMode('counts')}>
            Counts
          </Button>
          <Button variant={mode === 'rates' ? 'default' : 'outline'} onClick={() => setMode('rates')}>
            Rates
          </Button>
        </div>
        <span className="text-xs text-neutral-400">
          Opens are approximate (proxy prefetching inflates them).
        </span>
      </div>
      <ResponsiveContainer width="100%" height={360}>
        <LineChart data={buckets}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="period" />
          <YAxis tickFormatter={mode === 'rates' ? (v: number) => `${Math.round(v * 100)}%` : undefined} />
          <Tooltip
            formatter={
              mode === 'rates'
                ? (v) => (typeof v === 'number' ? `${(v * 100).toFixed(1)}%` : String(v ?? ''))
                : undefined
            }
          />
          <Legend />
          {series.map((s) => (
            <Line key={s.key} type="monotone" dataKey={s.key} stroke={s.color} dot={false} />
          ))}
        </LineChart>
      </ResponsiveContainer>
    </div>
  )
}
